import { AgRendererComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { EState, AgentStateCellParams, FOOTER_ROW_DEFAULT_VALUE, _stateColors } from '../current-agent-states.models';
import { CVLocalizationService } from '../../../../reusables/services/cv-localization.service';

@Component({
    selector: 'cv-state-cell-renderer',
    templateUrl: './agent-state-cell-renderer.component.html',
    styleUrls: ['./agent-state-cell-renderer.component.scss']
})
export class AgentStateCellRendererComponent implements AgRendererComponent {

    params: AgentStateCellParams;
    color: string;
    text: string = "";

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }

    refresh(params: AgentStateCellParams): boolean {
        this.params = params;
        this.getCircleColor(params);
        this.getStateName(params);

        return true;
    }
    agInit(params: AgentStateCellParams): void {
        this.params = params;
        this.getCircleColor(params);
        this.getStateName(params);
    }


    // params.data can be of type AgentStateDetails or AgentState - since this cell renderer is used in the table component and the modal component
    getCircleColor(params: AgentStateCellParams) {
        if (params.data.displayColor) { // AgentStateDetails class
            this.color = params.data.displayColor;
        }
        else { // AgentState class
            this.color = this.getStateColor(params.data.State, params.getColorMap());
        }
    }
    // the models have a few different access points to get to the same data, params.data.State.DisplayState is for the state name on the ag grid
    // in the table component and params.data.displayStatus is to get the state name on the modal ag grid
    getStateName(params: AgentStateCellParams) {
        if (params.data.State?.DisplayState !== undefined) { // AgentState class
            this.text = params.data.State.DisplayState;
        }
        else if (params.data.displayStatus !== undefined){ // AgentStateDetails class
            this.text = params.data.displayStatus;
        }
        else {
            this.text = ""; // this should never be hit
        }
    }

    /**
     * Returns the color for the specified state value.  The user may have specified a custom color for that state, which is returned instead of the default colors.
     *
     * @param state AgentState object to categorize. TYPE AgentState
     */
    getStateColor(state, _stateToColorMap) {
        // Object should be of type `AgentState` from CurrentAgentStates.cs, `state.State` should be the enum value.
        if (state && state.State !== undefined) {
            const unknownState = this.cvLocalizationService.getCachedText("Current_Agent_States_Module", "Unknown", "Unknown");
            const colorMapKey = state.DisplayState.toUpperCase();
            if (colorMapKey === FOOTER_ROW_DEFAULT_VALUE)  return "";
            if (_stateToColorMap && _stateToColorMap[colorMapKey])
                return _stateToColorMap[colorMapKey];

            // Default Colors:
            if (state.IsACW) {
                return _stateColors.orange;
            }
            if (state.IsDialer) {
                return _stateColors.blue;
            }
            if (state.DisplayState === unknownState) {
                return _stateColors.gray;
            }
            switch (state.State) {
                case EState.Available:
                    return _stateColors.green;
                case EState.Inbound:
                    return _stateColors.purple;
                case EState.Outbound:
                    return _stateColors.yellow;
                case EState.LoggedOut:
                    return _stateColors.gray;
                case EState.Unavailable:
                case EState.Custom:
                default: // possibly: Mixed
                    return _stateColors.red;
            }
        }
        return _stateColors.red;
    }
}
